"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.ReturnsHttpClient = exports.ReturnsRpcServer = exports.ReturnsNoopEventPublisher = exports.ReturnsRpcEventPublisher = exports.ReturnsNoopService = exports.ReturnsRpcClient = exports.RoutingKeys = exports.ContentRange = exports.GetMerchantListResult = exports.Statistics = exports.StatisticsPeriod = exports.StatisticsReturnState = exports.StatisticsReturnType = exports.StatisticsReturnReason = exports.CustomerOrder = exports.CustomerOrderReturn = exports.AttemptRedeliveryResponse = exports.AbandonRedeliveryResponse = exports.UndeliverableParcelFetch = exports.SearchCriteria = exports.Sort = exports.Filter = exports.Range = exports.ReturnFetch = exports.ActivityLog = exports.ExchangeItem = exports.Variant = exports.RefundItem = exports.Article = exports.Customer = exports.Order = exports.AbandonedReturn = exports.ReturnCreateResponse = exports.ExchangeItemCreate = exports.RefundItemCreate = exports.UndeliverableParcelId = exports.ExchangeItemId = exports.RefundItemId = exports.ReturnId = exports.InvalidEntity = exports.UndeliverableParcelState = exports.QueryFields = exports.ReturnState = exports.ReturnType = void 0;
var error_1 = require("../error");
var auth = require("../auth/index");
var hub = require("../hub/index");
var returns = require("../returns/index");
;
var ReturnType;
(function (ReturnType) {
    ReturnType["Mail"] = "Mail";
    ReturnType["Kiosk"] = "Kiosk";
})(ReturnType = exports.ReturnType || (exports.ReturnType = {}));
var ReturnState;
(function (ReturnState) {
    ReturnState["Pending"] = "Pending";
    ReturnState["Discarded"] = "Discarded";
    ReturnState["NotDroppedOff"] = "NotDroppedOff";
    ReturnState["Received"] = "Received";
    ReturnState["Dispatching"] = "Dispatching";
    ReturnState["NotDispatched"] = "NotDispatched";
    ReturnState["Delivered"] = "Delivered";
    ReturnState["DeliveryFailed"] = "DeliveryFailed";
    ReturnState["Processed"] = "Processed";
    ReturnState["PaidOut"] = "PaidOut";
})(ReturnState = exports.ReturnState || (exports.ReturnState = {}));
var QueryFields;
(function (QueryFields) {
    QueryFields["order_number"] = "order_number";
    QueryFields["return_id"] = "return_id";
    QueryFields["state"] = "state";
    QueryFields["shipment_id"] = "shipment_id";
    QueryFields["Empty"] = "Empty";
    QueryFields["customer_email"] = "customer_email";
    QueryFields["id"] = "id";
})(QueryFields = exports.QueryFields || (exports.QueryFields = {}));
var UndeliverableParcelState;
(function (UndeliverableParcelState) {
    UndeliverableParcelState["Registered"] = "Registered";
    UndeliverableParcelState["Redelivering"] = "Redelivering";
    UndeliverableParcelState["Expired"] = "Expired";
})(UndeliverableParcelState = exports.UndeliverableParcelState || (exports.UndeliverableParcelState = {}));
var utils_1 = require("../../utils");
var InvalidEntity;
(function (InvalidEntity) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("InvalidEntity"), InvalidEntityTypeMap);
    }
    InvalidEntity.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("InvalidEntity"), InvalidEntityTypeMap));
    }
    InvalidEntity.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("InvalidEntity"), InvalidEntityTypeMap);
    }
    InvalidEntity.fromValue = fromValue;
})(InvalidEntity = exports.InvalidEntity || (exports.InvalidEntity = {}));
var InvalidEntityTypeMap = {
    "InvalidEntity": (0, utils_1.o)([
        { json: "type", js: "type", typ: "undefined" },
        { json: "error", js: "error", typ: "string" },
        { json: "scope", js: "scope", typ: {
                unionMembers: [
                    { arrayItems: "string" },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "level", js: "level", typ: "string" },
        { json: "objectName", js: "objectName", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "message", js: "message", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } }
    ], false)
};
var ReturnId;
(function (ReturnId) {
    function of(value) {
        return value;
    }
    ReturnId.of = of;
    function fromValue(value) {
        return value;
    }
    ReturnId.fromValue = fromValue;
})(ReturnId = exports.ReturnId || (exports.ReturnId = {}));
var ReturnIdTypeMap = {
    "ReturnId": (0, utils_1.o)([
        "string"
    ], false)
};
var RefundItemId;
(function (RefundItemId) {
    function of(value) {
        return value;
    }
    RefundItemId.of = of;
    function fromValue(value) {
        return value;
    }
    RefundItemId.fromValue = fromValue;
})(RefundItemId = exports.RefundItemId || (exports.RefundItemId = {}));
var RefundItemIdTypeMap = {
    "RefundItemId": (0, utils_1.o)([
        "string"
    ], false)
};
var ExchangeItemId;
(function (ExchangeItemId) {
    function of(value) {
        return value;
    }
    ExchangeItemId.of = of;
    function fromValue(value) {
        return value;
    }
    ExchangeItemId.fromValue = fromValue;
})(ExchangeItemId = exports.ExchangeItemId || (exports.ExchangeItemId = {}));
var ExchangeItemIdTypeMap = {
    "ExchangeItemId": (0, utils_1.o)([
        "string"
    ], false)
};
var UndeliverableParcelId;
(function (UndeliverableParcelId) {
    function of(value) {
        return value;
    }
    UndeliverableParcelId.of = of;
    function fromValue(value) {
        return value;
    }
    UndeliverableParcelId.fromValue = fromValue;
})(UndeliverableParcelId = exports.UndeliverableParcelId || (exports.UndeliverableParcelId = {}));
var UndeliverableParcelIdTypeMap = {
    "UndeliverableParcelId": (0, utils_1.o)([
        "string"
    ], false)
};
(function (ReturnType) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ReturnType"), ReturnTypeTypeMap);
    }
    ReturnType.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ReturnType"), ReturnTypeTypeMap));
    }
    ReturnType.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ReturnType"), ReturnTypeTypeMap);
    }
    ReturnType.fromValue = fromValue;
})(ReturnType = exports.ReturnType || (exports.ReturnType = {}));
var ReturnTypeTypeMap = {
    "ReturnType": ["Mail", "Kiosk"]
};
(function (ReturnState) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ReturnState"), ReturnStateTypeMap);
    }
    ReturnState.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ReturnState"), ReturnStateTypeMap));
    }
    ReturnState.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ReturnState"), ReturnStateTypeMap);
    }
    ReturnState.fromValue = fromValue;
})(ReturnState = exports.ReturnState || (exports.ReturnState = {}));
var ReturnStateTypeMap = {
    "ReturnState": ["Pending", "Discarded", "NotDroppedOff", "Received", "Dispatching", "NotDispatched", "Delivered", "DeliveryFailed", "Processed", "PaidOut"]
};
var RefundItemCreate;
(function (RefundItemCreate) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("RefundItemCreate"), RefundItemCreateTypeMap);
    }
    RefundItemCreate.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("RefundItemCreate"), RefundItemCreateTypeMap));
    }
    RefundItemCreate.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("RefundItemCreate"), RefundItemCreateTypeMap);
    }
    RefundItemCreate.fromValue = fromValue;
})(RefundItemCreate = exports.RefundItemCreate || (exports.RefundItemCreate = {}));
var RefundItemCreateTypeMap = {
    "RefundItemCreate": (0, utils_1.o)([
        { json: "count", js: "count", typ: "number" },
        { json: "reason", js: "reason", typ: "string" },
        { json: "article", js: "article", typ: { "props": [{ json: "name", js: "name", typ: "string" },
                    { json: "barcode", js: "barcode", typ: {
                            unionMembers: [
                                "string",
                                null,
                                undefined
                            ]
                        } },
                    { json: "productId", js: "productId", typ: "string" },
                    { json: "variantId", js: "variantId", typ: "string" }] } }
    ], false)
};
var ExchangeItemCreate;
(function (ExchangeItemCreate) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ExchangeItemCreate"), ExchangeItemCreateTypeMap);
    }
    ExchangeItemCreate.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ExchangeItemCreate"), ExchangeItemCreateTypeMap));
    }
    ExchangeItemCreate.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ExchangeItemCreate"), ExchangeItemCreateTypeMap);
    }
    ExchangeItemCreate.fromValue = fromValue;
})(ExchangeItemCreate = exports.ExchangeItemCreate || (exports.ExchangeItemCreate = {}));
var ExchangeItemCreateTypeMap = {
    "ExchangeItemCreate": (0, utils_1.o)([
        { json: "productId", js: "productId", typ: "string" },
        { json: "productName", js: "productName", typ: "string" },
        { json: "oldVariant", js: "oldVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                    { json: "name", js: "name", typ: "string" },
                    { json: "barcode", js: "barcode", typ: {
                            unionMembers: [
                                "string",
                                null,
                                undefined
                            ]
                        } }] } },
        { json: "newVariant", js: "newVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                    { json: "name", js: "name", typ: "string" },
                    { json: "barcode", js: "barcode", typ: {
                            unionMembers: [
                                "string",
                                null,
                                undefined
                            ]
                        } }] } },
        { json: "reason", js: "reason", typ: "string" }
    ], false)
};
var ReturnCreateResponse;
(function (ReturnCreateResponse) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ReturnCreateResponse"), ReturnCreateResponseTypeMap);
    }
    ReturnCreateResponse.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ReturnCreateResponse"), ReturnCreateResponseTypeMap));
    }
    ReturnCreateResponse.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ReturnCreateResponse"), ReturnCreateResponseTypeMap);
    }
    ReturnCreateResponse.fromValue = fromValue;
})(ReturnCreateResponse = exports.ReturnCreateResponse || (exports.ReturnCreateResponse = {}));
var ReturnCreateResponseTypeMap = {
    "ReturnCreateResponse": (0, utils_1.o)([
        { json: "returnId", js: "returnId", typ: "string" },
        { json: "shipmentId", js: "shipmentId", typ: "string" }
    ], false)
};
var AbandonedReturn;
(function (AbandonedReturn) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("AbandonedReturn"), AbandonedReturnTypeMap);
    }
    AbandonedReturn.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("AbandonedReturn"), AbandonedReturnTypeMap));
    }
    AbandonedReturn.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("AbandonedReturn"), AbandonedReturnTypeMap);
    }
    AbandonedReturn.fromValue = fromValue;
})(AbandonedReturn = exports.AbandonedReturn || (exports.AbandonedReturn = {}));
var AbandonedReturnTypeMap = {
    "AbandonedReturn": (0, utils_1.o)([
        { json: "id", js: "id", typ: "string" },
        { json: "state", js: "state", typ: ["Pending", "Discarded", "NotDroppedOff", "Received", "Dispatching", "NotDispatched", "Delivered", "DeliveryFailed", "Processed", "PaidOut"] }
    ], false)
};
var Order;
(function (Order) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("Order"), OrderTypeMap);
    }
    Order.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("Order"), OrderTypeMap));
    }
    Order.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("Order"), OrderTypeMap);
    }
    Order.fromValue = fromValue;
})(Order = exports.Order || (exports.Order = {}));
var OrderTypeMap = {
    "Order": (0, utils_1.o)([
        { json: "orderNumber", js: "orderNumber", typ: "string" },
        { json: "merchantId", js: "merchantId", typ: "string" },
        { json: "merchantName", js: "merchantName", typ: "string" }
    ], false)
};
var Customer;
(function (Customer) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("Customer"), CustomerTypeMap);
    }
    Customer.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("Customer"), CustomerTypeMap));
    }
    Customer.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("Customer"), CustomerTypeMap);
    }
    Customer.fromValue = fromValue;
})(Customer = exports.Customer || (exports.Customer = {}));
var CustomerTypeMap = {
    "Customer": (0, utils_1.o)([
        { json: "emailAddress", js: "emailAddress", typ: "string" },
        { json: "customerId", js: "customerId", typ: "string" }
    ], false)
};
var Article;
(function (Article) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("Article"), ArticleTypeMap);
    }
    Article.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("Article"), ArticleTypeMap));
    }
    Article.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("Article"), ArticleTypeMap);
    }
    Article.fromValue = fromValue;
})(Article = exports.Article || (exports.Article = {}));
var ArticleTypeMap = {
    "Article": (0, utils_1.o)([
        { json: "name", js: "name", typ: "string" },
        { json: "barcode", js: "barcode", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "productId", js: "productId", typ: "string" },
        { json: "variantId", js: "variantId", typ: "string" }
    ], false)
};
var RefundItem;
(function (RefundItem) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("RefundItem"), RefundItemTypeMap);
    }
    RefundItem.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("RefundItem"), RefundItemTypeMap));
    }
    RefundItem.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("RefundItem"), RefundItemTypeMap);
    }
    RefundItem.fromValue = fromValue;
})(RefundItem = exports.RefundItem || (exports.RefundItem = {}));
var RefundItemTypeMap = {
    "RefundItem": (0, utils_1.o)([
        { json: "id", js: "id", typ: "string" },
        { json: "count", js: "count", typ: "number" },
        { json: "reason", js: "reason", typ: "string" },
        { json: "article", js: "article", typ: { "props": [{ json: "name", js: "name", typ: "string" },
                    { json: "barcode", js: "barcode", typ: {
                            unionMembers: [
                                "string",
                                null,
                                undefined
                            ]
                        } },
                    { json: "productId", js: "productId", typ: "string" },
                    { json: "variantId", js: "variantId", typ: "string" }] } }
    ], false)
};
var Variant;
(function (Variant) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("Variant"), VariantTypeMap);
    }
    Variant.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("Variant"), VariantTypeMap));
    }
    Variant.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("Variant"), VariantTypeMap);
    }
    Variant.fromValue = fromValue;
})(Variant = exports.Variant || (exports.Variant = {}));
var VariantTypeMap = {
    "Variant": (0, utils_1.o)([
        { json: "id", js: "id", typ: "string" },
        { json: "name", js: "name", typ: "string" },
        { json: "barcode", js: "barcode", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } }
    ], false)
};
var ExchangeItem;
(function (ExchangeItem) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ExchangeItem"), ExchangeItemTypeMap);
    }
    ExchangeItem.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ExchangeItem"), ExchangeItemTypeMap));
    }
    ExchangeItem.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ExchangeItem"), ExchangeItemTypeMap);
    }
    ExchangeItem.fromValue = fromValue;
})(ExchangeItem = exports.ExchangeItem || (exports.ExchangeItem = {}));
var ExchangeItemTypeMap = {
    "ExchangeItem": (0, utils_1.o)([
        { json: "id", js: "id", typ: "string" },
        { json: "productId", js: "productId", typ: "string" },
        { json: "productName", js: "productName", typ: "string" },
        { json: "oldVariant", js: "oldVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                    { json: "name", js: "name", typ: "string" },
                    { json: "barcode", js: "barcode", typ: {
                            unionMembers: [
                                "string",
                                null,
                                undefined
                            ]
                        } }] } },
        { json: "newVariant", js: "newVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                    { json: "name", js: "name", typ: "string" },
                    { json: "barcode", js: "barcode", typ: {
                            unionMembers: [
                                "string",
                                null,
                                undefined
                            ]
                        } }] } },
        { json: "reason", js: "reason", typ: "string" }
    ], false)
};
var ActivityLog;
(function (ActivityLog) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ActivityLog"), ActivityLogTypeMap);
    }
    ActivityLog.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ActivityLog"), ActivityLogTypeMap));
    }
    ActivityLog.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ActivityLog"), ActivityLogTypeMap);
    }
    ActivityLog.fromValue = fromValue;
})(ActivityLog = exports.ActivityLog || (exports.ActivityLog = {}));
var ActivityLogTypeMap = {
    "ActivityLog": (0, utils_1.o)([
        { json: "state", js: "state", typ: ["Pending", "Discarded", "NotDroppedOff", "Received", "Dispatching", "NotDispatched", "Delivered", "DeliveryFailed", "Processed", "PaidOut"] },
        { json: "timestamp", js: "timestamp", typ: Date }
    ], false)
};
var ReturnFetch;
(function (ReturnFetch) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ReturnFetch"), ReturnFetchTypeMap);
    }
    ReturnFetch.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ReturnFetch"), ReturnFetchTypeMap));
    }
    ReturnFetch.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ReturnFetch"), ReturnFetchTypeMap);
    }
    ReturnFetch.fromValue = fromValue;
})(ReturnFetch = exports.ReturnFetch || (exports.ReturnFetch = {}));
var ReturnFetchTypeMap = {
    "ReturnFetch": (0, utils_1.o)([
        { json: "id", js: "id", typ: "string" },
        { json: "type", js: "type", typ: ["Mail", "Kiosk"] },
        { json: "shipmentId", js: "shipmentId", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "order", js: "order", typ: { "props": [{ json: "orderNumber", js: "orderNumber", typ: "string" },
                    { json: "merchantId", js: "merchantId", typ: "string" },
                    { json: "merchantName", js: "merchantName", typ: "string" }] } },
        { json: "customer", js: "customer", typ: { "props": [{ json: "emailAddress", js: "emailAddress", typ: "string" },
                    { json: "customerId", js: "customerId", typ: "string" }] } },
        { json: "state", js: "state", typ: ["Pending", "Discarded", "NotDroppedOff", "Received", "Dispatching", "NotDispatched", "Delivered", "DeliveryFailed", "Processed", "PaidOut"] },
        { json: "refunds", js: "refunds", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                { json: "count", js: "count", typ: "number" },
                                { json: "reason", js: "reason", typ: "string" },
                                { json: "article", js: "article", typ: { "props": [{ json: "name", js: "name", typ: "string" },
                                            { json: "barcode", js: "barcode", typ: {
                                                    unionMembers: [
                                                        "string",
                                                        null,
                                                        undefined
                                                    ]
                                                } },
                                            { json: "productId", js: "productId", typ: "string" },
                                            { json: "variantId", js: "variantId", typ: "string" }] } }] } },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "exchanges", js: "exchanges", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                { json: "productId", js: "productId", typ: "string" },
                                { json: "productName", js: "productName", typ: "string" },
                                { json: "oldVariant", js: "oldVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                                            { json: "name", js: "name", typ: "string" },
                                            { json: "barcode", js: "barcode", typ: {
                                                    unionMembers: [
                                                        "string",
                                                        null,
                                                        undefined
                                                    ]
                                                } }] } },
                                { json: "newVariant", js: "newVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                                            { json: "name", js: "name", typ: "string" },
                                            { json: "barcode", js: "barcode", typ: {
                                                    unionMembers: [
                                                        "string",
                                                        null,
                                                        undefined
                                                    ]
                                                } }] } },
                                { json: "reason", js: "reason", typ: "string" }] } },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "activity", js: "activity", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "state", js: "state", typ: ["Pending", "Discarded", "NotDroppedOff", "Received", "Dispatching", "NotDispatched", "Delivered", "DeliveryFailed", "Processed", "PaidOut"] },
                                { json: "timestamp", js: "timestamp", typ: Date }] } },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "createdAt", js: "createdAt", typ: Date },
        { json: "updatedAt", js: "updatedAt", typ: Date }
    ], false)
};
(function (QueryFields) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("QueryFields"), QueryFieldsTypeMap);
    }
    QueryFields.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("QueryFields"), QueryFieldsTypeMap));
    }
    QueryFields.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("QueryFields"), QueryFieldsTypeMap);
    }
    QueryFields.fromValue = fromValue;
})(QueryFields = exports.QueryFields || (exports.QueryFields = {}));
var QueryFieldsTypeMap = {
    "QueryFields": ["order_number", "return_id", "state", "shipment_id", "Empty", "customer_email", "id"]
};
var Range;
(function (Range) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("Range"), RangeTypeMap);
    }
    Range.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("Range"), RangeTypeMap));
    }
    Range.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("Range"), RangeTypeMap);
    }
    Range.fromValue = fromValue;
})(Range = exports.Range || (exports.Range = {}));
var RangeTypeMap = {
    "Range": (0, utils_1.o)([
        { json: "page", js: "page", typ: "number" },
        { json: "perPage", js: "perPage", typ: "number" }
    ], false)
};
var Filter;
(function (Filter) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("Filter"), FilterTypeMap);
    }
    Filter.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("Filter"), FilterTypeMap));
    }
    Filter.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("Filter"), FilterTypeMap);
    }
    Filter.fromValue = fromValue;
})(Filter = exports.Filter || (exports.Filter = {}));
var FilterTypeMap = {
    "Filter": (0, utils_1.o)([
        { json: "field", js: "field", typ: ["order_number", "return_id", "state", "shipment_id", "Empty", "customer_email", "id"] },
        { json: "value", js: "value", typ: "string" }
    ], false)
};
var Sort;
(function (Sort) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("Sort"), SortTypeMap);
    }
    Sort.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("Sort"), SortTypeMap));
    }
    Sort.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("Sort"), SortTypeMap);
    }
    Sort.fromValue = fromValue;
})(Sort = exports.Sort || (exports.Sort = {}));
var SortTypeMap = {
    "Sort": (0, utils_1.o)([
        { json: "field", js: "field", typ: ["order_number", "return_id", "state", "shipment_id", "Empty", "customer_email", "id"] },
        { json: "order", js: "order", typ: "string" }
    ], false)
};
var SearchCriteria;
(function (SearchCriteria) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("SearchCriteria"), SearchCriteriaTypeMap);
    }
    SearchCriteria.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("SearchCriteria"), SearchCriteriaTypeMap));
    }
    SearchCriteria.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("SearchCriteria"), SearchCriteriaTypeMap);
    }
    SearchCriteria.fromValue = fromValue;
})(SearchCriteria = exports.SearchCriteria || (exports.SearchCriteria = {}));
var SearchCriteriaTypeMap = {
    "SearchCriteria": (0, utils_1.o)([
        { json: "range", js: "range", typ: {
                unionMembers: [
                    {
                        props: [{ json: "page", js: "page", typ: "number" },
                            { json: "perPage", js: "perPage", typ: "number" }]
                    },
                    null,
                    undefined
                ]
            } },
        { json: "sort", js: "sort", typ: {
                unionMembers: [
                    {
                        props: [{ json: "field", js: "field", typ: ["order_number", "return_id", "state", "shipment_id", "Empty", "customer_email", "id"] },
                            { json: "order", js: "order", typ: "string" }]
                    },
                    null,
                    undefined
                ]
            } },
        { json: "filter", js: "filter", typ: {
                unionMembers: [
                    {
                        props: [{ json: "field", js: "field", typ: ["order_number", "return_id", "state", "shipment_id", "Empty", "customer_email", "id"] },
                            { json: "value", js: "value", typ: "string" }]
                    },
                    null,
                    undefined
                ]
            } }
    ], false)
};
(function (UndeliverableParcelState) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("UndeliverableParcelState"), UndeliverableParcelStateTypeMap);
    }
    UndeliverableParcelState.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("UndeliverableParcelState"), UndeliverableParcelStateTypeMap));
    }
    UndeliverableParcelState.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("UndeliverableParcelState"), UndeliverableParcelStateTypeMap);
    }
    UndeliverableParcelState.fromValue = fromValue;
})(UndeliverableParcelState = exports.UndeliverableParcelState || (exports.UndeliverableParcelState = {}));
var UndeliverableParcelStateTypeMap = {
    "UndeliverableParcelState": ["Registered", "Redelivering", "Expired"]
};
var UndeliverableParcelFetch;
(function (UndeliverableParcelFetch) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("UndeliverableParcelFetch"), UndeliverableParcelFetchTypeMap);
    }
    UndeliverableParcelFetch.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("UndeliverableParcelFetch"), UndeliverableParcelFetchTypeMap));
    }
    UndeliverableParcelFetch.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("UndeliverableParcelFetch"), UndeliverableParcelFetchTypeMap);
    }
    UndeliverableParcelFetch.fromValue = fromValue;
})(UndeliverableParcelFetch = exports.UndeliverableParcelFetch || (exports.UndeliverableParcelFetch = {}));
var UndeliverableParcelFetchTypeMap = {
    "UndeliverableParcelFetch": (0, utils_1.o)([
        { json: "merchantId", js: "merchantId", typ: "string" },
        { json: "parcelNumber", js: "parcelNumber", typ: "string" },
        { json: "redeliveryShipmentId", js: "redeliveryShipmentId", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "daysUntilExpiry", js: "daysUntilExpiry", typ: "number" },
        { json: "state", js: "state", typ: ["Registered", "Redelivering", "Expired"] }
    ], false)
};
var AbandonRedeliveryResponse;
(function (AbandonRedeliveryResponse) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("AbandonRedeliveryResponse"), AbandonRedeliveryResponseTypeMap);
    }
    AbandonRedeliveryResponse.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("AbandonRedeliveryResponse"), AbandonRedeliveryResponseTypeMap));
    }
    AbandonRedeliveryResponse.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("AbandonRedeliveryResponse"), AbandonRedeliveryResponseTypeMap);
    }
    AbandonRedeliveryResponse.fromValue = fromValue;
})(AbandonRedeliveryResponse = exports.AbandonRedeliveryResponse || (exports.AbandonRedeliveryResponse = {}));
var AbandonRedeliveryResponseTypeMap = {
    "AbandonRedeliveryResponse": (0, utils_1.o)([], false)
};
var AttemptRedeliveryResponse;
(function (AttemptRedeliveryResponse) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("AttemptRedeliveryResponse"), AttemptRedeliveryResponseTypeMap);
    }
    AttemptRedeliveryResponse.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("AttemptRedeliveryResponse"), AttemptRedeliveryResponseTypeMap));
    }
    AttemptRedeliveryResponse.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("AttemptRedeliveryResponse"), AttemptRedeliveryResponseTypeMap);
    }
    AttemptRedeliveryResponse.fromValue = fromValue;
})(AttemptRedeliveryResponse = exports.AttemptRedeliveryResponse || (exports.AttemptRedeliveryResponse = {}));
var AttemptRedeliveryResponseTypeMap = {
    "AttemptRedeliveryResponse": (0, utils_1.o)([
        { json: "shipmentId", js: "shipmentId", typ: "string" }
    ], false)
};
var CustomerOrderReturn;
(function (CustomerOrderReturn) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("CustomerOrderReturn"), CustomerOrderReturnTypeMap);
    }
    CustomerOrderReturn.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("CustomerOrderReturn"), CustomerOrderReturnTypeMap));
    }
    CustomerOrderReturn.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("CustomerOrderReturn"), CustomerOrderReturnTypeMap);
    }
    CustomerOrderReturn.fromValue = fromValue;
})(CustomerOrderReturn = exports.CustomerOrderReturn || (exports.CustomerOrderReturn = {}));
var CustomerOrderReturnTypeMap = {
    "CustomerOrderReturn": (0, utils_1.o)([
        { json: "id", js: "id", typ: "string" },
        { json: "type", js: "type", typ: ["Mail", "Kiosk"] },
        { json: "shipmentId", js: "shipmentId", typ: {
                unionMembers: [
                    "string",
                    null,
                    undefined
                ]
            } },
        { json: "state", js: "state", typ: ["Pending", "Discarded", "NotDroppedOff", "Received", "Dispatching", "NotDispatched", "Delivered", "DeliveryFailed", "Processed", "PaidOut"] },
        { json: "refunds", js: "refunds", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                { json: "count", js: "count", typ: "number" },
                                { json: "reason", js: "reason", typ: "string" },
                                { json: "article", js: "article", typ: { "props": [{ json: "name", js: "name", typ: "string" },
                                            { json: "barcode", js: "barcode", typ: {
                                                    unionMembers: [
                                                        "string",
                                                        null,
                                                        undefined
                                                    ]
                                                } },
                                            { json: "productId", js: "productId", typ: "string" },
                                            { json: "variantId", js: "variantId", typ: "string" }] } }] } },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "exchanges", js: "exchanges", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                { json: "productId", js: "productId", typ: "string" },
                                { json: "productName", js: "productName", typ: "string" },
                                { json: "oldVariant", js: "oldVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                                            { json: "name", js: "name", typ: "string" },
                                            { json: "barcode", js: "barcode", typ: {
                                                    unionMembers: [
                                                        "string",
                                                        null,
                                                        undefined
                                                    ]
                                                } }] } },
                                { json: "newVariant", js: "newVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                                            { json: "name", js: "name", typ: "string" },
                                            { json: "barcode", js: "barcode", typ: {
                                                    unionMembers: [
                                                        "string",
                                                        null,
                                                        undefined
                                                    ]
                                                } }] } },
                                { json: "reason", js: "reason", typ: "string" }] } },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "createdAt", js: "createdAt", typ: Date }
    ], false)
};
var CustomerOrder;
(function (CustomerOrder) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("CustomerOrder"), CustomerOrderTypeMap);
    }
    CustomerOrder.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("CustomerOrder"), CustomerOrderTypeMap));
    }
    CustomerOrder.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("CustomerOrder"), CustomerOrderTypeMap);
    }
    CustomerOrder.fromValue = fromValue;
})(CustomerOrder = exports.CustomerOrder || (exports.CustomerOrder = {}));
var CustomerOrderTypeMap = {
    "CustomerOrder": (0, utils_1.o)([
        { json: "orderNumber", js: "orderNumber", typ: "string" },
        { json: "returns", js: "returns", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                { json: "type", js: "type", typ: ["Mail", "Kiosk"] },
                                { json: "shipmentId", js: "shipmentId", typ: {
                                        unionMembers: [
                                            "string",
                                            null,
                                            undefined
                                        ]
                                    } },
                                { json: "state", js: "state", typ: ["Pending", "Discarded", "NotDroppedOff", "Received", "Dispatching", "NotDispatched", "Delivered", "DeliveryFailed", "Processed", "PaidOut"] },
                                { json: "refunds", js: "refunds", typ: {
                                        unionMembers: [
                                            { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                                        { json: "count", js: "count", typ: "number" },
                                                        { json: "reason", js: "reason", typ: "string" },
                                                        { json: "article", js: "article", typ: { "props": [{ json: "name", js: "name", typ: "string" },
                                                                    { json: "barcode", js: "barcode", typ: {
                                                                            unionMembers: [
                                                                                "string",
                                                                                null,
                                                                                undefined
                                                                            ]
                                                                        } },
                                                                    { json: "productId", js: "productId", typ: "string" },
                                                                    { json: "variantId", js: "variantId", typ: "string" }] } }] } },
                                            null,
                                            undefined,
                                            []
                                        ]
                                    } },
                                { json: "exchanges", js: "exchanges", typ: {
                                        unionMembers: [
                                            { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                                        { json: "productId", js: "productId", typ: "string" },
                                                        { json: "productName", js: "productName", typ: "string" },
                                                        { json: "oldVariant", js: "oldVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                                                                    { json: "name", js: "name", typ: "string" },
                                                                    { json: "barcode", js: "barcode", typ: {
                                                                            unionMembers: [
                                                                                "string",
                                                                                null,
                                                                                undefined
                                                                            ]
                                                                        } }] } },
                                                        { json: "newVariant", js: "newVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                                                                    { json: "name", js: "name", typ: "string" },
                                                                    { json: "barcode", js: "barcode", typ: {
                                                                            unionMembers: [
                                                                                "string",
                                                                                null,
                                                                                undefined
                                                                            ]
                                                                        } }] } },
                                                        { json: "reason", js: "reason", typ: "string" }] } },
                                            null,
                                            undefined,
                                            []
                                        ]
                                    } },
                                { json: "createdAt", js: "createdAt", typ: Date }] } },
                    null,
                    undefined,
                    []
                ]
            } }
    ], false)
};
var StatisticsReturnReason;
(function (StatisticsReturnReason) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("StatisticsReturnReason"), StatisticsReturnReasonTypeMap);
    }
    StatisticsReturnReason.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("StatisticsReturnReason"), StatisticsReturnReasonTypeMap));
    }
    StatisticsReturnReason.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("StatisticsReturnReason"), StatisticsReturnReasonTypeMap);
    }
    StatisticsReturnReason.fromValue = fromValue;
})(StatisticsReturnReason = exports.StatisticsReturnReason || (exports.StatisticsReturnReason = {}));
var StatisticsReturnReasonTypeMap = {
    "StatisticsReturnReason": (0, utils_1.o)([
        { json: "reason", js: "reason", typ: "string" },
        { json: "quantity", js: "quantity", typ: "number" }
    ], false)
};
var StatisticsReturnType;
(function (StatisticsReturnType) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("StatisticsReturnType"), StatisticsReturnTypeTypeMap);
    }
    StatisticsReturnType.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("StatisticsReturnType"), StatisticsReturnTypeTypeMap));
    }
    StatisticsReturnType.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("StatisticsReturnType"), StatisticsReturnTypeTypeMap);
    }
    StatisticsReturnType.fromValue = fromValue;
})(StatisticsReturnType = exports.StatisticsReturnType || (exports.StatisticsReturnType = {}));
var StatisticsReturnTypeTypeMap = {
    "StatisticsReturnType": (0, utils_1.o)([
        { json: "returnType", js: "returnType", typ: ["Mail", "Kiosk"] },
        { json: "quantity", js: "quantity", typ: "number" }
    ], false)
};
var StatisticsReturnState;
(function (StatisticsReturnState) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("StatisticsReturnState"), StatisticsReturnStateTypeMap);
    }
    StatisticsReturnState.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("StatisticsReturnState"), StatisticsReturnStateTypeMap));
    }
    StatisticsReturnState.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("StatisticsReturnState"), StatisticsReturnStateTypeMap);
    }
    StatisticsReturnState.fromValue = fromValue;
})(StatisticsReturnState = exports.StatisticsReturnState || (exports.StatisticsReturnState = {}));
var StatisticsReturnStateTypeMap = {
    "StatisticsReturnState": (0, utils_1.o)([
        { json: "state", js: "state", typ: ["Pending", "Discarded", "NotDroppedOff", "Received", "Dispatching", "NotDispatched", "Delivered", "DeliveryFailed", "Processed", "PaidOut"] },
        { json: "quantity", js: "quantity", typ: "number" }
    ], false)
};
var StatisticsPeriod;
(function (StatisticsPeriod) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("StatisticsPeriod"), StatisticsPeriodTypeMap);
    }
    StatisticsPeriod.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("StatisticsPeriod"), StatisticsPeriodTypeMap));
    }
    StatisticsPeriod.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("StatisticsPeriod"), StatisticsPeriodTypeMap);
    }
    StatisticsPeriod.fromValue = fromValue;
})(StatisticsPeriod = exports.StatisticsPeriod || (exports.StatisticsPeriod = {}));
var StatisticsPeriodTypeMap = {
    "StatisticsPeriod": (0, utils_1.o)([
        { json: "start", js: "start", typ: Date },
        { json: "end", js: "end", typ: Date }
    ], false)
};
var Statistics;
(function (Statistics) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("Statistics"), StatisticsTypeMap);
    }
    Statistics.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("Statistics"), StatisticsTypeMap));
    }
    Statistics.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("Statistics"), StatisticsTypeMap);
    }
    Statistics.fromValue = fromValue;
})(Statistics = exports.Statistics || (exports.Statistics = {}));
var StatisticsTypeMap = {
    "Statistics": (0, utils_1.o)([
        { json: "total", js: "total", typ: "number" },
        { json: "returnReasons", js: "returnReasons", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "reason", js: "reason", typ: "string" },
                                { json: "quantity", js: "quantity", typ: "number" }] } },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "returnTypes", js: "returnTypes", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "returnType", js: "returnType", typ: ["Mail", "Kiosk"] },
                                { json: "quantity", js: "quantity", typ: "number" }] } },
                    null,
                    undefined,
                    []
                ]
            } },
        { json: "returnStates", js: "returnStates", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "state", js: "state", typ: ["Pending", "Discarded", "NotDroppedOff", "Received", "Dispatching", "NotDispatched", "Delivered", "DeliveryFailed", "Processed", "PaidOut"] },
                                { json: "quantity", js: "quantity", typ: "number" }] } },
                    null,
                    undefined,
                    []
                ]
            } }
    ], false)
};
var GetMerchantListResult;
(function (GetMerchantListResult) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("GetMerchantListResult"), GetMerchantListResultTypeMap);
    }
    GetMerchantListResult.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("GetMerchantListResult"), GetMerchantListResultTypeMap));
    }
    GetMerchantListResult.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("GetMerchantListResult"), GetMerchantListResultTypeMap);
    }
    GetMerchantListResult.fromValue = fromValue;
})(GetMerchantListResult = exports.GetMerchantListResult || (exports.GetMerchantListResult = {}));
var GetMerchantListResultTypeMap = {
    "GetMerchantListResult": (0, utils_1.o)([
        { json: "contentRange", js: "contentRange", typ: { "props": [{ json: "first", js: "first", typ: "number" },
                    { json: "last", js: "last", typ: "number" }] } },
        { json: "result", js: "result", typ: {
                unionMembers: [
                    { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                { json: "type", js: "type", typ: ["Mail", "Kiosk"] },
                                { json: "shipmentId", js: "shipmentId", typ: {
                                        unionMembers: [
                                            "string",
                                            null,
                                            undefined
                                        ]
                                    } },
                                { json: "order", js: "order", typ: { "props": [{ json: "orderNumber", js: "orderNumber", typ: "string" },
                                            { json: "merchantId", js: "merchantId", typ: "string" },
                                            { json: "merchantName", js: "merchantName", typ: "string" }] } },
                                { json: "customer", js: "customer", typ: { "props": [{ json: "emailAddress", js: "emailAddress", typ: "string" },
                                            { json: "customerId", js: "customerId", typ: "string" }] } },
                                { json: "state", js: "state", typ: ["Pending", "Discarded", "NotDroppedOff", "Received", "Dispatching", "NotDispatched", "Delivered", "DeliveryFailed", "Processed", "PaidOut"] },
                                { json: "refunds", js: "refunds", typ: {
                                        unionMembers: [
                                            { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                                        { json: "count", js: "count", typ: "number" },
                                                        { json: "reason", js: "reason", typ: "string" },
                                                        { json: "article", js: "article", typ: { "props": [{ json: "name", js: "name", typ: "string" },
                                                                    { json: "barcode", js: "barcode", typ: {
                                                                            unionMembers: [
                                                                                "string",
                                                                                null,
                                                                                undefined
                                                                            ]
                                                                        } },
                                                                    { json: "productId", js: "productId", typ: "string" },
                                                                    { json: "variantId", js: "variantId", typ: "string" }] } }] } },
                                            null,
                                            undefined,
                                            []
                                        ]
                                    } },
                                { json: "exchanges", js: "exchanges", typ: {
                                        unionMembers: [
                                            { arrayItems: { "props": [{ json: "id", js: "id", typ: "string" },
                                                        { json: "productId", js: "productId", typ: "string" },
                                                        { json: "productName", js: "productName", typ: "string" },
                                                        { json: "oldVariant", js: "oldVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                                                                    { json: "name", js: "name", typ: "string" },
                                                                    { json: "barcode", js: "barcode", typ: {
                                                                            unionMembers: [
                                                                                "string",
                                                                                null,
                                                                                undefined
                                                                            ]
                                                                        } }] } },
                                                        { json: "newVariant", js: "newVariant", typ: { "props": [{ json: "id", js: "id", typ: "string" },
                                                                    { json: "name", js: "name", typ: "string" },
                                                                    { json: "barcode", js: "barcode", typ: {
                                                                            unionMembers: [
                                                                                "string",
                                                                                null,
                                                                                undefined
                                                                            ]
                                                                        } }] } },
                                                        { json: "reason", js: "reason", typ: "string" }] } },
                                            null,
                                            undefined,
                                            []
                                        ]
                                    } },
                                { json: "activity", js: "activity", typ: {
                                        unionMembers: [
                                            { arrayItems: { "props": [{ json: "state", js: "state", typ: ["Pending", "Discarded", "NotDroppedOff", "Received", "Dispatching", "NotDispatched", "Delivered", "DeliveryFailed", "Processed", "PaidOut"] },
                                                        { json: "timestamp", js: "timestamp", typ: Date }] } },
                                            null,
                                            undefined,
                                            []
                                        ]
                                    } },
                                { json: "createdAt", js: "createdAt", typ: Date },
                                { json: "updatedAt", js: "updatedAt", typ: Date }] } },
                    null,
                    undefined,
                    []
                ]
            } }
    ], false)
};
var ContentRange;
(function (ContentRange) {
    function fromJson(json) {
        return (0, utils_1.cast)(JSON.parse(json), (0, utils_1.r)("ContentRange"), ContentRangeTypeMap);
    }
    ContentRange.fromJson = fromJson;
    function toJson(value) {
        return JSON.stringify((0, utils_1.uncast)(value, (0, utils_1.r)("ContentRange"), ContentRangeTypeMap));
    }
    ContentRange.toJson = toJson;
    function fromValue(val) {
        return (0, utils_1.cast)(val, (0, utils_1.r)("ContentRange"), ContentRangeTypeMap);
    }
    ContentRange.fromValue = fromValue;
})(ContentRange = exports.ContentRange || (exports.ContentRange = {}));
var ContentRangeTypeMap = {
    "ContentRange": (0, utils_1.o)([
        { json: "first", js: "first", typ: "number" },
        { json: "last", js: "last", typ: "number" }
    ], false)
};
var RoutingKeys;
(function (RoutingKeys) {
    RoutingKeys["ReturnCreate"] = "com.droppa.returns.returnCreate";
    RoutingKeys["BackdateStateChange"] = "com.droppa.returns.backdateStateChange";
    RoutingKeys["AbandonReturns"] = "com.droppa.returns.abandonReturns";
    RoutingKeys["ReturnById"] = "com.droppa.returns.returnById";
    RoutingKeys["GetMerchantReturnsList"] = "com.droppa.returns.getMerchantReturnsList";
    RoutingKeys["ReturnByShipmentId"] = "com.droppa.returns.returnByShipmentId";
    RoutingKeys["FetchUndeliverableParcel"] = "com.droppa.returns.fetchUndeliverableParcel";
    RoutingKeys["CreateUndeliverableParcel"] = "com.droppa.returns.createUndeliverableParcel";
    RoutingKeys["AbandonRedelivery"] = "com.droppa.returns.abandonRedelivery";
    RoutingKeys["AttemptRedelivery"] = "com.droppa.returns.attemptRedelivery";
    RoutingKeys["FindCustomerReturns"] = "com.droppa.returns.findCustomerReturns";
    RoutingKeys["FindExistingOrderReturns"] = "com.droppa.returns.findExistingOrderReturns";
    RoutingKeys["GetStatistics"] = "com.droppa.returns.getStatistics";
})(RoutingKeys = exports.RoutingKeys || (exports.RoutingKeys = {}));
(function (RoutingKeys) {
    RoutingKeys.All = [RoutingKeys.ReturnCreate, RoutingKeys.BackdateStateChange, RoutingKeys.AbandonReturns, RoutingKeys.ReturnById, RoutingKeys.GetMerchantReturnsList, RoutingKeys.ReturnByShipmentId, RoutingKeys.FetchUndeliverableParcel, RoutingKeys.CreateUndeliverableParcel, RoutingKeys.AbandonRedelivery, RoutingKeys.AttemptRedelivery, RoutingKeys.FindCustomerReturns, RoutingKeys.FindExistingOrderReturns, RoutingKeys.GetStatistics];
    function from(value) {
        var routingKey = RoutingKeys.All.find(function (x) { return x.toString() === value; });
        if (routingKey != undefined) {
            return routingKey;
        }
        throw new Error("Unknown routing key: ".concat(value));
    }
    RoutingKeys.from = from;
})(RoutingKeys = exports.RoutingKeys || (exports.RoutingKeys = {}));
var ReturnsRpcClient = /** @class */ (function () {
    function ReturnsRpcClient(client) {
        this.client = client;
    }
    ReturnsRpcClient.prototype.returnCreate = function (type, order, refunds, exchanges, customerEmail) {
        var request = { type: type, order: order, refunds: refunds, exchanges: exchanges, customerEmail: customerEmail };
        return this.client.request(RoutingKeys.ReturnCreate, request);
    };
    ReturnsRpcClient.prototype.backdateStateChange = function (returnId, state, days /* Int */) {
        var request = { returnId: returnId, state: state, days: days };
        return this.client.broadcast(RoutingKeys.BackdateStateChange, request);
    };
    ReturnsRpcClient.prototype.abandonReturns = function () {
        var request = {};
        return this.client.request(RoutingKeys.AbandonReturns, request);
    };
    ReturnsRpcClient.prototype.returnById = function (returnId) {
        var request = { returnId: returnId };
        return this.client.request(RoutingKeys.ReturnById, request);
    };
    ReturnsRpcClient.prototype.getMerchantReturnsList = function (merchantId, searchCriteria) {
        var request = { merchantId: merchantId, searchCriteria: searchCriteria };
        return this.client.request(RoutingKeys.GetMerchantReturnsList, request);
    };
    ReturnsRpcClient.prototype.returnByShipmentId = function (shipmentId /* UUID */) {
        var request = { shipmentId: shipmentId };
        return this.client.request(RoutingKeys.ReturnByShipmentId, request);
    };
    ReturnsRpcClient.prototype.fetchUndeliverableParcel = function (undeliverableParcelId) {
        var request = { undeliverableParcelId: undeliverableParcelId };
        return this.client.request(RoutingKeys.FetchUndeliverableParcel, request);
    };
    ReturnsRpcClient.prototype.createUndeliverableParcel = function (merchantId, parcelNumber) {
        var request = { merchantId: merchantId, parcelNumber: parcelNumber };
        return this.client.request(RoutingKeys.CreateUndeliverableParcel, request);
    };
    ReturnsRpcClient.prototype.abandonRedelivery = function (undeliverableParcelId) {
        var request = { undeliverableParcelId: undeliverableParcelId };
        return this.client.request(RoutingKeys.AbandonRedelivery, request);
    };
    ReturnsRpcClient.prototype.attemptRedelivery = function (undeliverableParcelId) {
        var request = { undeliverableParcelId: undeliverableParcelId };
        return this.client.request(RoutingKeys.AttemptRedelivery, request);
    };
    ReturnsRpcClient.prototype.findCustomerReturns = function (customerEmail) {
        var request = { customerEmail: customerEmail };
        return this.client.request(RoutingKeys.FindCustomerReturns, request);
    };
    ReturnsRpcClient.prototype.findExistingOrderReturns = function (customerEmail, orderNumber) {
        var request = { customerEmail: customerEmail, orderNumber: orderNumber };
        return this.client.request(RoutingKeys.FindExistingOrderReturns, request);
    };
    ReturnsRpcClient.prototype.getStatistics = function (period) {
        var request = { period: period };
        return this.client.request(RoutingKeys.GetStatistics, request);
    };
    return ReturnsRpcClient;
}());
exports.ReturnsRpcClient = ReturnsRpcClient;
var ReturnsNoopService = /** @class */ (function () {
    function ReturnsNoopService() {
    }
    ReturnsNoopService.prototype.returnCreate = function (type, order, refunds, exchanges, customerEmail) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.returnCreate() not implemented");
            });
        });
    };
    /**
     * Endpoint for QA purposes
     */
    ReturnsNoopService.prototype.backdateStateChange = function (returnId, state, days /* Int */) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, null];
            });
        });
    };
    /**
     * Endpoint for QA purposes
     */
    ReturnsNoopService.prototype.abandonReturns = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.abandonReturns() not implemented");
            });
        });
    };
    ReturnsNoopService.prototype.returnById = function (returnId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.returnById() not implemented");
            });
        });
    };
    ReturnsNoopService.prototype.getMerchantReturnsList = function (merchantId, searchCriteria) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.getMerchantReturnsList() not implemented");
            });
        });
    };
    ReturnsNoopService.prototype.returnByShipmentId = function (shipmentId /* UUID */) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.returnByShipmentId() not implemented");
            });
        });
    };
    ReturnsNoopService.prototype.fetchUndeliverableParcel = function (undeliverableParcelId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.fetchUndeliverableParcel() not implemented");
            });
        });
    };
    /**
     * Create an undeliverable parcel in Registered state.
     *
     * Notify customer by email that their order could not be delivered.
     *
     * Called by hub.
     */
    ReturnsNoopService.prototype.createUndeliverableParcel = function (merchantId, parcelNumber) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.createUndeliverableParcel() not implemented");
            });
        });
    };
    /**
     * Do not redeliver parcel to customer. Notifies hub.
     */
    ReturnsNoopService.prototype.abandonRedelivery = function (undeliverableParcelId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.abandonRedelivery() not implemented");
            });
        });
    };
    /**
     * Redeliver parcel to customer. Create shipment label and notify hub.
     *
     * Populates redeliveryShipmentId field.
     */
    ReturnsNoopService.prototype.attemptRedelivery = function (undeliverableParcelId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.attemptRedelivery() not implemented");
            });
        });
    };
    /**
     * Find all returns for given customer.
     */
    ReturnsNoopService.prototype.findCustomerReturns = function (customerEmail) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.findCustomerReturns() not implemented");
            });
        });
    };
    /**
     * Find all existing returns for an order during the pre-registration flow.
     */
    ReturnsNoopService.prototype.findExistingOrderReturns = function (customerEmail, orderNumber) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.findExistingOrderReturns() not implemented");
            });
        });
    };
    /**
     * Get merchant statistics for requested period. To be shown on admin
     * dashboard.
     */
    ReturnsNoopService.prototype.getStatistics = function (period) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("ReturnsNoopService.getStatistics() not implemented");
            });
        });
    };
    // Event published by "hub" service
    ReturnsNoopService.prototype.returnProcessingCompleted = function (id, isStraightForward) {
        return Promise.resolve();
    };
    // Event published by "hub" service
    ReturnsNoopService.prototype.parcelReceived = function (shipmentId /* UUID */, barcode) {
        return Promise.resolve();
    };
    return ReturnsNoopService;
}());
exports.ReturnsNoopService = ReturnsNoopService;
var ReturnsRpcEventPublisher = /** @class */ (function () {
    function ReturnsRpcEventPublisher(client) {
        this.client = client;
    }
    return ReturnsRpcEventPublisher;
}());
exports.ReturnsRpcEventPublisher = ReturnsRpcEventPublisher;
var ReturnsNoopEventPublisher = /** @class */ (function () {
    function ReturnsNoopEventPublisher() {
    }
    return ReturnsNoopEventPublisher;
}());
exports.ReturnsNoopEventPublisher = ReturnsNoopEventPublisher;
var ReturnsRpcServer = /** @class */ (function () {
    function ReturnsRpcServer(service) {
        this.service = service;
        this.handlerMapCached = this.generateHandlerMap();
    }
    ReturnsRpcServer.prototype.handle = function (routingKey, body) {
        var method = this.handlerMapCached[routingKey];
        if (method == null) {
            throw new Error("Unknown routing key ".concat(routingKey));
        }
        return method(body);
    };
    ReturnsRpcServer.prototype.handlerMap = function () { return this.handlerMapCached; };
    ReturnsRpcServer.prototype.generateHandlerMap = function () {
        var _a;
        return _a = {},
            _a[RoutingKeys.ReturnCreate] = this.returnCreate.bind(this),
            _a[RoutingKeys.BackdateStateChange] = this.backdateStateChange.bind(this),
            _a[RoutingKeys.AbandonReturns] = this.abandonReturns.bind(this),
            _a[RoutingKeys.ReturnById] = this.returnById.bind(this),
            _a[RoutingKeys.GetMerchantReturnsList] = this.getMerchantReturnsList.bind(this),
            _a[RoutingKeys.ReturnByShipmentId] = this.returnByShipmentId.bind(this),
            _a[RoutingKeys.FetchUndeliverableParcel] = this.fetchUndeliverableParcel.bind(this),
            _a[RoutingKeys.CreateUndeliverableParcel] = this.createUndeliverableParcel.bind(this),
            _a[RoutingKeys.AbandonRedelivery] = this.abandonRedelivery.bind(this),
            _a[RoutingKeys.AttemptRedelivery] = this.attemptRedelivery.bind(this),
            _a[RoutingKeys.FindCustomerReturns] = this.findCustomerReturns.bind(this),
            _a[RoutingKeys.FindExistingOrderReturns] = this.findExistingOrderReturns.bind(this),
            _a[RoutingKeys.GetStatistics] = this.getStatistics.bind(this),
            _a[hub.RoutingKeys.ReturnProcessingCompleted] = this.returnProcessingCompleted.bind(this),
            _a[hub.RoutingKeys.ParcelReceived] = this.parcelReceived.bind(this),
            _a;
    };
    ReturnsRpcServer.prototype.routingKeys = function () {
        return [RoutingKeys.ReturnCreate.toString(), RoutingKeys.BackdateStateChange.toString(), RoutingKeys.AbandonReturns.toString(), RoutingKeys.ReturnById.toString(), RoutingKeys.GetMerchantReturnsList.toString(), RoutingKeys.ReturnByShipmentId.toString(), RoutingKeys.FetchUndeliverableParcel.toString(), RoutingKeys.CreateUndeliverableParcel.toString(), RoutingKeys.AbandonRedelivery.toString(), RoutingKeys.AttemptRedelivery.toString(), RoutingKeys.FindCustomerReturns.toString(), RoutingKeys.FindExistingOrderReturns.toString(), RoutingKeys.GetStatistics.toString(), hub.RoutingKeys.ReturnProcessingCompleted.toString(), hub.RoutingKeys.ParcelReceived.toString()];
    };
    ReturnsRpcServer.prototype.returnCreate = function (_a) {
        var type = _a.type, order = _a.order, refunds = _a.refunds, exchanges = _a.exchanges, customerEmail = _a.customerEmail;
        return this.service.returnCreate(type, order, refunds, exchanges, customerEmail);
    };
    ReturnsRpcServer.prototype.backdateStateChange = function (_a) {
        var returnId = _a.returnId, state = _a.state, days = _a.days;
        return this.service.backdateStateChange(returnId, state, days);
    };
    ReturnsRpcServer.prototype.abandonReturns = function (_a) {
        return this.service.abandonReturns();
    };
    ReturnsRpcServer.prototype.returnById = function (_a) {
        var returnId = _a.returnId;
        return this.service.returnById(returnId);
    };
    ReturnsRpcServer.prototype.getMerchantReturnsList = function (_a) {
        var merchantId = _a.merchantId, searchCriteria = _a.searchCriteria;
        return this.service.getMerchantReturnsList(merchantId, searchCriteria);
    };
    ReturnsRpcServer.prototype.returnByShipmentId = function (_a) {
        var shipmentId = _a.shipmentId;
        return this.service.returnByShipmentId(shipmentId);
    };
    ReturnsRpcServer.prototype.fetchUndeliverableParcel = function (_a) {
        var undeliverableParcelId = _a.undeliverableParcelId;
        return this.service.fetchUndeliverableParcel(undeliverableParcelId);
    };
    ReturnsRpcServer.prototype.createUndeliverableParcel = function (_a) {
        var merchantId = _a.merchantId, parcelNumber = _a.parcelNumber;
        return this.service.createUndeliverableParcel(merchantId, parcelNumber);
    };
    ReturnsRpcServer.prototype.abandonRedelivery = function (_a) {
        var undeliverableParcelId = _a.undeliverableParcelId;
        return this.service.abandonRedelivery(undeliverableParcelId);
    };
    ReturnsRpcServer.prototype.attemptRedelivery = function (_a) {
        var undeliverableParcelId = _a.undeliverableParcelId;
        return this.service.attemptRedelivery(undeliverableParcelId);
    };
    ReturnsRpcServer.prototype.findCustomerReturns = function (_a) {
        var customerEmail = _a.customerEmail;
        return this.service.findCustomerReturns(customerEmail);
    };
    ReturnsRpcServer.prototype.findExistingOrderReturns = function (_a) {
        var customerEmail = _a.customerEmail, orderNumber = _a.orderNumber;
        return this.service.findExistingOrderReturns(customerEmail, orderNumber);
    };
    ReturnsRpcServer.prototype.getStatistics = function (_a) {
        var period = _a.period;
        return this.service.getStatistics(period);
    };
    ReturnsRpcServer.prototype.returnProcessingCompleted = function (_a) {
        var id = _a.id, isStraightForward = _a.isStraightForward;
        return this.service.returnProcessingCompleted(id, isStraightForward);
    };
    ReturnsRpcServer.prototype.parcelReceived = function (_a) {
        var shipmentId = _a.shipmentId, barcode = _a.barcode;
        return this.service.parcelReceived(shipmentId, barcode);
    };
    return ReturnsRpcServer;
}());
exports.ReturnsRpcServer = ReturnsRpcServer;
var ReturnsHttpClient = /** @class */ (function () {
    function ReturnsHttpClient(client) {
        this.client = client;
    }
    ReturnsHttpClient.prototype.returnCreate = function (type, order, refunds, exchanges, customerEmail) {
        var request = { type: type, order: order, refunds: refunds, exchanges: exchanges, customerEmail: customerEmail };
        return this.client.call("returns", "returnCreate", request).then(function (result) { return ReturnCreateResponse.fromValue(result); }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.backdateStateChange = function (returnId, state, days /* Int */) {
        var request = { returnId: returnId, state: state, days: days };
        return this.client.call("returns", "backdateStateChange", request).then(function (result) {
            if (result === null) {
                return result;
            }
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: "Type mismatch" });
        }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.abandonReturns = function () {
        var request = {};
        return this.client.call("returns", "abandonReturns", request).then(function (result) {
            if (typeof result === "object" && Array.isArray(result)) {
                var r_1 = result;
                r_1.every(function (r) { return returns.AbandonedReturn.fromValue(r); });
                return result;
            }
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: "Type mismatch" });
        }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.returnById = function (returnId) {
        var request = { returnId: returnId };
        return this.client.call("returns", "returnById", request).then(function (result) { return returns.ReturnFetch.fromValue(result); }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.getMerchantReturnsList = function (merchantId, searchCriteria) {
        var request = { merchantId: merchantId, searchCriteria: searchCriteria };
        return this.client.call("returns", "getMerchantReturnsList", request).then(function (result) { return returns.GetMerchantListResult.fromValue(result); }, function (e) {
            return e.response.json().then(function (e) {
                var err;
                if (e.error === 'TokenExpired') {
                    try {
                        err = auth.TokenExpired.fromValue(e);
                    }
                    catch (_a) { }
                }
                if (e.error === 'InvalidToken') {
                    try {
                        err = auth.InvalidToken.fromValue(e);
                    }
                    catch (_b) { }
                }
                if (e.error === 'InvalidCredentials') {
                    try {
                        err = auth.InvalidCredentials.fromValue(e);
                    }
                    catch (_c) { }
                }
                if (e.error === 'UnsupportedAudience') {
                    try {
                        err = auth.UnsupportedAudience.fromValue(e);
                    }
                    catch (_d) { }
                }
                if (e.error === 'UsernameAlreadyTaken') {
                    try {
                        err = auth.UsernameAlreadyTaken.fromValue(e);
                    }
                    catch (_e) { }
                }
                if (e.error === 'InvalidUsername') {
                    try {
                        err = auth.InvalidUsername.fromValue(e);
                    }
                    catch (_f) { }
                }
                if (e.error === 'InvalidPassword') {
                    try {
                        err = auth.InvalidPassword.fromValue(e);
                    }
                    catch (_g) { }
                }
                if (e.error === 'MissingEmailOrMerchantId') {
                    try {
                        err = auth.MissingEmailOrMerchantId.fromValue(e);
                    }
                    catch (_h) { }
                }
                if (err) {
                    throw err;
                }
                throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
            });
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.returnByShipmentId = function (shipmentId /* UUID */) {
        var request = { shipmentId: shipmentId };
        return this.client.call("returns", "returnByShipmentId", request).then(function (result) { return returns.ReturnFetch.fromValue(result); }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.fetchUndeliverableParcel = function (undeliverableParcelId) {
        var request = { undeliverableParcelId: undeliverableParcelId };
        return this.client.call("returns", "fetchUndeliverableParcel", request).then(function (result) { return returns.UndeliverableParcelFetch.fromValue(result); }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.createUndeliverableParcel = function (merchantId, parcelNumber) {
        var request = { merchantId: merchantId, parcelNumber: parcelNumber };
        return this.client.call("returns", "createUndeliverableParcel", request).then(function (result) { return returns.UndeliverableParcelId.fromValue(result); }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.abandonRedelivery = function (undeliverableParcelId) {
        var request = { undeliverableParcelId: undeliverableParcelId };
        return this.client.call("returns", "abandonRedelivery", request).then(function (result) { return AbandonRedeliveryResponse.fromValue(result); }, function (e) {
            return e.response.json().then(function (e) {
                var err;
                if (e.error === 'InvalidEntity') {
                    try {
                        err = returns.InvalidEntity.fromValue(e);
                    }
                    catch (_a) { }
                }
                if (err) {
                    throw err;
                }
                throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
            });
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.attemptRedelivery = function (undeliverableParcelId) {
        var request = { undeliverableParcelId: undeliverableParcelId };
        return this.client.call("returns", "attemptRedelivery", request).then(function (result) { return AttemptRedeliveryResponse.fromValue(result); }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.findCustomerReturns = function (customerEmail) {
        var request = { customerEmail: customerEmail };
        return this.client.call("returns", "findCustomerReturns", request).then(function (result) {
            if (typeof result === "object" && Array.isArray(result)) {
                var r_2 = result;
                r_2.every(function (r) { return returns.CustomerOrder.fromValue(r); });
                return result;
            }
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: "Type mismatch" });
        }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.findExistingOrderReturns = function (customerEmail, orderNumber) {
        var request = { customerEmail: customerEmail, orderNumber: orderNumber };
        return this.client.call("returns", "findExistingOrderReturns", request).then(function (result) {
            if (typeof result === "object" && Array.isArray(result)) {
                var r_3 = result;
                r_3.every(function (r) { return returns.CustomerOrderReturn.fromValue(r); });
                return result;
            }
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: "Type mismatch" });
        }, function (e) {
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    ReturnsHttpClient.prototype.getStatistics = function (period) {
        var request = { period: period };
        return this.client.call("returns", "getStatistics", request).then(function (result) { return returns.Statistics.fromValue(result); }, function (e) {
            return e.response.json().then(function (e) {
                var err;
                if (e.error === 'TokenExpired') {
                    try {
                        err = auth.TokenExpired.fromValue(e);
                    }
                    catch (_a) { }
                }
                if (e.error === 'InvalidToken') {
                    try {
                        err = auth.InvalidToken.fromValue(e);
                    }
                    catch (_b) { }
                }
                if (e.error === 'InvalidCredentials') {
                    try {
                        err = auth.InvalidCredentials.fromValue(e);
                    }
                    catch (_c) { }
                }
                if (e.error === 'UnsupportedAudience') {
                    try {
                        err = auth.UnsupportedAudience.fromValue(e);
                    }
                    catch (_d) { }
                }
                if (e.error === 'UsernameAlreadyTaken') {
                    try {
                        err = auth.UsernameAlreadyTaken.fromValue(e);
                    }
                    catch (_e) { }
                }
                if (e.error === 'InvalidUsername') {
                    try {
                        err = auth.InvalidUsername.fromValue(e);
                    }
                    catch (_f) { }
                }
                if (e.error === 'InvalidPassword') {
                    try {
                        err = auth.InvalidPassword.fromValue(e);
                    }
                    catch (_g) { }
                }
                if (e.error === 'MissingEmailOrMerchantId') {
                    try {
                        err = auth.MissingEmailOrMerchantId.fromValue(e);
                    }
                    catch (_h) { }
                }
                if (err) {
                    throw err;
                }
                throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
            });
            throw __assign(__assign({}, error_1.HttpErrors.SerialisationError), { message: e.message });
        });
    };
    return ReturnsHttpClient;
}());
exports.ReturnsHttpClient = ReturnsHttpClient;
//# sourceMappingURL=index.js.map